import React from "react";

const HomePage = () => {
  return (
    <div>
      <h1>Welcome to SLASCANH Forms</h1>
      <p>Use the form URLs to start filling forms.</p>
    </div>
    
  );
};

export default HomePage;
